import { StandardProps } from "@/types/types";
import Script from "next/script";

export function ProductCardList({
  productListingData,
  configProps,
}: Pick<StandardProps, "productListingData" | "configProps">) {
  const productIds = productListingData?.products?.map((product) => ({
    pimProductId: product.productId,
  }));

  const encodedProducts = btoa(JSON.stringify(productIds));
  const pclConfig =
    (configProps as Record<string, string> | undefined)?.pclConfig ?? "plp";
  const heading = productListingData?.pageInformation?.heading;

  return (
    <>
      <product-card-list-ui
        products={encodedProducts}
        config={pclConfig}
        heading={heading}
      ></product-card-list-ui>

      <Script
        src="/product-card-list-ui/static/client.js"
        type="module"
      ></Script>
    </>
  );
}
